import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Garde de rôle (défense en profondeur — la protection réelle est côté API, 403).
 * Redirige vers l'accueil si l'utilisateur n'est pas admin DT.
 */
export function AdminOnly({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ padding: 24, color: 'var(--text-mute)' }}>Chargement…</div>;
  if (!user?.is_admin) return <Navigate to="/" replace />;
  return <>{children}</>;
}
